var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProicon = function SvgProicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#pro_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 10,
    x: 2,
    y: 3,
    fill: "url(#pro_icon_svg__b)",
    rx: 4.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pro_icon_svg__c)",
    d: "M14.88 8.16c0 .98-.63 1.46-1.3 1.46s-1.3-.48-1.3-1.46.63-1.46 1.3-1.46 1.3.48 1.3 1.46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pro_icon_svg__d)",
    d: "M8.87 6.7v.9h.97c.3 0 .5-.17.5-.45 0-.29-.2-.45-.5-.45h-.97Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pro_icon_svg__e)",
    d: "M5.3 7.72V6.7h.87c.37 0 .62.17.62.5 0 .34-.25.52-.62.52h-.88Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pro_icon_svg__f)",
    fillRule: "evenodd",
    d: "M2.27 4.37C2 4.9 2 5.6 2 7v2c0 1.4 0 2.1.27 2.63.24.48.62.86 1.1 1.1C3.9 13 4.6 13 6 13h8c1.4 0 2.1 0 2.64-.27a2.5 2.5 0 0 0 1.09-1.1C18 11.1 18 10.4 18 9V7c0-1.4 0-2.1-.27-2.63a2.5 2.5 0 0 0-1.1-1.1C16.1 3 15.4 3 14 3H6c-1.4 0-2.1 0-2.63.27a2.5 2.5 0 0 0-1.1 1.1Zm9.24 3.79c0 1.46 1.04 2.16 2.07 2.16 1.03 0 2.08-.7 2.08-2.16C15.66 6.7 14.6 6 13.58 6s-2.07.7-2.07 2.16Zm-3.4 1.98V6.06c0-.04.02-.06.06-.06h1.64c.76 0 1.28.4 1.28 1.15 0 .52-.36.93-.77 1.1l.9 1.89v.02c0 .03-.02.04-.05.04h-.7c-.02 0-.05-.02-.08-.06l-.9-1.85h-.62v1.85c0 .04-.02.06-.06.06h-.64c-.04 0-.06-.02-.06-.06ZM4.54 6.06v4.08c0 .04.02.06.06.06h.63c.05 0 .06-.02.06-.06V8.41h.85c.92 0 1.42-.47 1.42-1.2 0-.74-.5-1.21-1.42-1.21H4.6c-.04 0-.06.02-.06.06Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pro_icon_svg__b",
    x1: 4.5,
    x2: 11,
    y1: 6,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F0EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pro_icon_svg__c",
    x1: 5,
    x2: 16.03,
    y1: 2.5,
    y2: 9.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FF4848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pro_icon_svg__d",
    x1: 5,
    x2: 16.03,
    y1: 2.5,
    y2: 9.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FF4848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pro_icon_svg__e",
    x1: 5,
    x2: 16.03,
    y1: 2.5,
    y2: 9.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FF4848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pro_icon_svg__f",
    x1: 5,
    x2: 16.03,
    y1: 2.5,
    y2: 9.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FF4848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pro_icon_svg__a",
    width: 20,
    height: 14,
    x: 0,
    y: 3,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 2,
    result: "effect1_dropShadow_1531_951"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.933333 0 0 0 0 0.286275 0 0 0 0 0.364706 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1531_951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1531_951",
    result: "shape"
  })))));
};
export default SvgProicon;